import React from "react";

const Linkedin = () => {
  return (
    <a
      href="https://www.linkedin.com/in/duchaidev/"
      target="_blank"
      className="group px-[7px] py-1"
      rel="noreferrer"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        className="transition-all duration-300 group-hover:fill-green-300 fill-white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.01172 21.7682H7.92188V10.0208H4.01172V21.7682ZM8.17578 6.39844C8.1645 5.81163 7.96137 5.32639 7.56641 4.94271C7.17144 4.55903 6.6467 4.36719 5.99219 4.36719C5.33767 4.36719 4.80447 4.55903 4.39258 4.94271C3.98069 5.32639 3.77474 5.81163 3.77474 6.39844C3.77474 6.97396 3.97504 7.45638 4.37565 7.8457C4.77626 8.23503 5.29818 8.42969 5.94141 8.42969H5.95833C6.62413 8.42969 7.16016 8.23503 7.56641 7.8457C7.97266 7.45638 8.17578 6.97396 8.17578 6.39844ZM18.0781 21.7682H21.9883V15.0313C21.9883 13.2934 21.5764 11.9787 20.7526 11.0872C19.9288 10.1957 18.8398 9.75 17.4857 9.75C15.951 9.75 14.7717 10.4102 13.9479 11.7305H13.9818V10.0208H10.0716C10.1055 10.7656 10.1055 14.6814 10.0716 21.7682H13.9818V15.2005C13.9818 14.7717 14.0213 14.4557 14.1003 14.2526C14.2695 13.8576 14.5234 13.5219 14.862 13.2454C15.2005 12.969 15.6181 12.8307 16.1146 12.8307C17.4236 12.8307 18.0781 13.7166 18.0781 15.4883V21.7682ZM26 4.875V21.125C26 22.4679 25.5232 23.6161 24.5697 24.5697C23.6161 25.5232 22.4679 26 21.125 26H4.875C3.53212 26 2.3839 25.5232 1.43034 24.5697C0.47678 23.6161 0 22.4679 0 21.125V4.875C0 3.53212 0.47678 2.3839 1.43034 1.43034C2.3839 0.47678 3.53212 0 4.875 0H21.125C22.4679 0 23.6161 0.47678 24.5697 1.43034C25.5232 2.3839 26 3.53212 26 4.875Z"
          //   fill="white"
        />
      </svg>
    </a>
  );
};

export default Linkedin;
